module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-componant"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v("\n  You have been here for " + _vm._s(_vm.counter) + " seconds.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c8deeac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/server-count.vue
// module id = 97
// module chunks = 0